import React, { useEffect } from 'react';
import { head } from 'ramda';
import PropTypes from 'prop-types';
import { Box, Typography, TextField } from '@material-ui/core';
import MortgageSurveyQuestionPresenter, { validate } from 'presenters/MortgageSurveyQuestionPresenter';
import MortgageSurveyPresenter from 'presenters/MortgageSurveyPresenter';

import useStyles from './useStyles';

const TextFieldQuestion = props => {
  const { question, onChange, surveyValues, onValidate } = props;
  const classes = useStyles();

  const field = head(MortgageSurveyQuestionPresenter.surveyValueFields(question));
  const currentValue = MortgageSurveyPresenter[field](surveyValues);

  useEffect(() => {
    const validations = MortgageSurveyQuestionPresenter.validations(question);
    const { isValid } = validate(validations, currentValue);
    onValidate(isValid);
  }, [currentValue]);

  const placeholder = MortgageSurveyQuestionPresenter.placeholder(question);

  const handleValueChange = ({ target: { value } }) => {
    onChange([{ field, value }]);
  };

  return (
    <Box width="100%">
      <Typography variant="h1">{MortgageSurveyQuestionPresenter.label(question)}</Typography>
      <Box mt={2} />
      <Typography variant="body1">{MortgageSurveyQuestionPresenter.description(question)}</Typography>
      <Box mt={4} />
      <TextField
        multiline
        rows={4}
        onChange={handleValueChange}
        variant="outlined"
        value={currentValue}
        className={classes.field}
        placeholder={placeholder}
      />
    </Box>
  );
};

TextFieldQuestion.propTypes = {
  question: MortgageSurveyQuestionPresenter.shape().isRequired,
  onChange: PropTypes.func.isRequired,
  surveyValues: MortgageSurveyPresenter.shape().isRequired,
  onValidate: PropTypes.func.isRequired,
};

export default TextFieldQuestion;



// WEBPACK FOOTER //
// ./src/sharedComponents/MortgageSurvey/components/TextFieldQuestion/TextFieldQuestion.js